<template>
  <div>
    <div class="card">
      <div v-if="isTableGreyFeatures" class="section">
        <div class="section-title title-box">
          <base-section-title title="候选供应商">
            <!-- <template v-slot:right-tool>
              <el-button
                type="primary"
                size="medium"
                class="flex-center m-b-10"
                @click="handleExportPdf"
              >导出pdf</el-button>
            </template> -->
          </base-section-title>
        </div>

        <div class="section-content">
          <el-form v-if="awardMethodInfo" class="detail-form m-t-24">
            <el-form-item label="授标方式：">
              <span>{{ awardMethodInfo.label || '-' }}</span>
            </el-form-item>
            <el-form-item label="授标方式说明：">
              <span>{{ awardMethodInfo.desc || '-' }}</span>
            </el-form-item>
          </el-form>

          <award-sheet
            class="m-t-24"
            :is-wuling="true"
            :is-dollar="isDollar"
            :table-data="detailVoList"
            :span-num-obj="getNumOfEachMaterial()"
            :require-tax="requireTax"
          />
          <el-form class="detail-form m-t-24">
            <el-form-item label="上传记录或其他文件：">
              <upload
                v-if="candidateInfo.candidateAttachmentIds"
                :file-id-before.sync="candidateInfo.candidateAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId',
                  singleUpload: false
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-else class="section">
        <div class="section-content">
          <purchase-list-award
            class="m-t-24"
            :table-data="detailVoList"
            :item-schema-list="itemSchemaList"
            :is-dollar="isDollar"
            :pdf-api="getInquiryCandidateAwardPdf"
            :require-tax="requireTax"
            title="候选供应商"
            :span-num-obj="getNumOfEachMaterial()"
          />
          <el-form class="detail-form m-t-24">
            <el-form-item label="上传记录或其他文件：">
              <upload
                v-if="candidateInfo.candidateAttachmentIds"
                :file-id-before.sync="candidateInfo.candidateAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div v-if="cancelList.length" class="card">
      <div v-for="item in cancelList" :key="item.cancelDate" class="section">
        <base-section-title class="section-title" title="取消采购品目" />

        <div class="section-content p-b-10">
          <flow-item-sheet-wuling
            v-if="isTableGreyFeatures"
            :reason-form="{
              cancelReason: item.cancelReason,
              cancelAttachmentIds: item.cancelAttachmentIds
            }"
            :table-data="item.cancelItemList"
            :is-dollar="isDollar"
            :cancel-date="item.cancelDate"
            disabled
          />

          <flow-item-sheet
            v-else
            :reason-form="{
              cancelReason: item.cancelReason,
              cancelAttachmentIds: item.cancelAttachmentIds
            }"
            :table-data="item.cancelItemList"
            :item-schema-list="itemSchemaList"
            :is-dollar="isDollar"
            :cancel-date="item.cancelDate"
            disabled
          />
        </div>
      </div>
    </div>

    <div v-if="isTableGreyFeatures" class="card">
      <div class="section">
        <base-section-title class="section-title" title="内部附件上传" />

        <div class="section-content">
          <el-form class="detail-form m-t-24">
            <el-form-item label="内部附件上传：">
              <upload
                v-if="internalAttachmentIds && internalAttachmentIds.length"
                :file-id-before="internalAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-----中标候选人保证金退款设置------>
    <div v-if="!!Number(guaranteeFee)" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="保证金退款设置" />
        </div>
        <div class="section-content">
          <el-form
            ref="bondSetForm"
            class="detail-form"
            label-width="180px"
            label-suffix="："
          >
            <el-form-item label="保证金退款审核设置" prop="refundGuaranteeMode">
              <span
                :class="[
                  'text-bold',
                  {
                    'text-danger':
                      candidateInfo.refundGuaranteeMode ===
                      bondBidRefundTypeDict.NO.value
                  }
                ]"
              >
                {{
                  bondBidRefundTypeDict.translate(
                    candidateInfo.refundGuaranteeMode
                  ).label
                }}
              </span>
            </el-form-item>
            <a-alert type="info">
              <common-purchase-bond-refund-copywriter slot="message" />
            </a-alert>
          </el-form>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="候选供应商公示" />
        </div>
        <div class="section-content p-b-10">
          <el-row>
            <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
              <el-form
                class="detail-form"
                label-suffix="："
                label-width="100px"
              >
                <el-form-item label="发布日期">
                  <span>
                    {{ candidateInfo.noticePublishTime | getNormDayFilter }}
                  </span>
                </el-form-item>
                <el-form-item label="发布状态">
                  <el-tag
                    :type="
                      noticeReleaseStatusDict.translate(
                        candidateInfo.noticeReleaseStatus
                      ).type
                    "
                    size="small"
                  >
                    {{
                      noticeReleaseStatusDict.translate(
                        candidateInfo.noticeReleaseStatus
                      ).label || '-'
                    }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="发布公示">
                  <content-item
                    :value="
                      inquiryWhetherToPublishDict.translate(
                        candidateInfo.publicity
                      ).label
                    "
                  />
                </el-form-item>
                <el-form-item v-if="candidateInfo.noticeTitle" label="公示标题">
                  <content-item :value="candidateInfo.noticeTitle" />
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-form v-if="candidateInfo.noticeTitle" class="detail-form">
            <el-form-item>
              <u-editor v-model="candidateInfo.noticeContent" disabled />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import PurchaseListAward from '@/components/common/PurchaseListComponent/PurchaseListAward'
import ContentItem from '@/components/common/ContentItem'
import AwardSheet from '@/components/inquiry/AwardSheet.vue'
import Upload from '@/components/common/Upload/index'
import FlowItemSheet from '@/components/inquiry/FlowItemSheet.vue'
import FlowItemSheetWuling from '@/components/inquiry/FlowItemSheetWuling.vue'
import CommonPurchaseBondRefundCopywriter from '@/components/copywriter/CommonPurchaseBondRefundCopywriter'

// 数据字典
import {
  inquiryWhetherToPublishDict,
  awardMethodDict
} from '@/dictionary/project/inquiry'
import {
  noticeReleaseStatusDict,
  bondBidRefundTypeDict
} from '@/dictionary/project/common'
import { watermarkTypeDict } from '@/dictionary/template'

// 工具函数
import { countRepeatNum } from '@/utils/utils'
import { getFileUrlByFileIdApi, htmlToPdfApi } from '@/api/up-file'
import { generateMaterielHtml } from '@/components/common/PurchaseListComponent/generate-materiel-html'
import { mapActions } from 'vuex'

// 后端api
import { getInquiryCandidateAwardPdfApi } from '@/api/procure/inquiry'

export default {
  name: 'OrderCandidateTemplate',

  components: {
    BaseSectionTitle,
    UEditor,
    PurchaseListAward,
    ContentItem,
    AwardSheet,
    Upload,
    FlowItemSheet,
    FlowItemSheetWuling,
    CommonPurchaseBondRefundCopywriter
  },

  props: {
    // 候选供应商列表
    detailVoList: {
      type: Array,
      required: true
    },

    // 候选公示信息
    candidateInfo: {
      type: Object,
      required: true
    },

    // 是否含税
    requireTax: {
      type: Boolean,
      required: true
    },

    // 字段设置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 候选id
    candidateId: {
      type: [Number, String],
      default: ''
    },

    isDollar: {
      type: Boolean,
      default: false
    },

    // 内部附件
    internalAttachmentIds: {
      type: [Array, String],
      default: ''
    },

    isTableGreyFeatures: {
      type: Boolean,
      default: false
    },

    orderId: {
      type: [Number, String],
      default: 0
    },

    guaranteeFee: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      inquiryWhetherToPublishDict,
      noticeReleaseStatusDict,
      bondBidRefundTypeDict
    }
  },

  computed: {
    /**
     * 一键选择授标方式
     */
    awardMethodInfo() {
      return this.candidateInfo.awardType
        ? awardMethodDict.translate(this.candidateInfo.awardType)
        : null
    },

    cancelList() {
      return (this.candidateInfo.cancelList || []).filter(
        item => item.candidateId === this.candidateId
      )
    }
  },

  methods: {
    ...mapActions('company', ['showGreyFeature']),

    /**
     * 获取pdf数据
     */
    getInquiryCandidateAwardPdf() {
      return new Promise((resolve, reject) => {
        getInquiryCandidateAwardPdfApi(
          this.orderId || this.$route.params.orderId,
          this.candidateId
        )
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 下载pdf
    async handleExportPdf() {
      const pdfData = await this.getPdfData()
      const tableHtml = generateMaterielHtml({
        pdfData,
        pdfTitle: '询比候选表',
        isDollar: this.isDollar,
        title: '候选供应商',
        requireTax: this.requireTax
      })
      this.downloadPdf(tableHtml)
    },

    // 获取比价表pdf数据
    getPdfData() {
      return new Promise((resolve, reject) => {
        this.getInquiryCandidateAwardPdf()
          .then(res => {
            const data = res?.data || {}
            resolve(data)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            throw err
          })
      })
    },

    // 下载pdf
    downloadPdf(content) {
      const postData = {
        name: `询比候选表.pdf`,
        watermark: {
          watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
          watermarkWord: '精彩纵横云采购平台'
        },
        content: content
      }
      htmlToPdfApi(postData)
        .then(res => {
          getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
            window.open(fileRes.data.external, '_self')
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },
    // 获取每批品目成交供应商数量
    getNumOfEachMaterial() {
      const tempList = this.detailVoList || []
      return countRepeatNum(tempList, 'materielId')
    }
  }
}
</script>

<style scoped></style>
